<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reload="reload" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_head_colorName_mainColor_colorCard') ||
                  '颜色名称/色系/色号搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-if="allow('A')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditDialog', { type: 'add' })"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small">
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
            <el-form-item :label="$l('INDEX.Status') || '有效状态'">
              <el-checkbox-group v-model="form.colorStatusList">
                <el-checkbox label="A">
                  {{ $l('form_label_colorStatus_A') || '草稿' }}
                </el-checkbox>
                <el-checkbox label="S">
                  {{ $l('form_label_colorStatus_S') || '提交审核' }}
                </el-checkbox>
                <el-checkbox label="Y">
                  {{ $l('form_label_colorStatus_Y') || '审核通过' }}
                </el-checkbox>
                <el-checkbox label="R">
                  {{ $l('form_label_colorStatus_R') || '审核驳回' }}
                </el-checkbox>
                <el-checkbox label="N">
                  {{ $l('form_label_colorStatus_N') || '已删除' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('table_head_colorName') || '颜色名称'"
              prop="colorName"
            >
              <el-input
                clearable
                v-model.trim="form.colorName"
                size="small"
                :placeholder="
                  $l('table_head_please_input_colorName') || '请输入颜色名称'
                "
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('table_head_colorNameEn') || '颜色名称英文'"
              prop="colorNameEn"
            >
              <el-input clearable v-model.trim="form.colorNameEn" size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('table_head_mainColor') || '色系'"
              prop="mainColor"
            >
              <dict-select
                clearable
                v-model="form.mainColor"
                filterable
                :placeholder="
                  $l('table_head_please_select_color') || '请选择色系'
                "
                url="/master/master/color/main/color"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('table_label_isCustomer') || '是否客户颜色'"
              prop="isCustomer"
            >
              <el-select
                v-model="form.isCustomer"
                size="small"
                style="width: 100%"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
              >
                <el-option
                  key="Y"
                  :label="$l('table_label_isCustomer_Y') || '是'"
                  value="Y"
                >
                </el-option>
                <el-option
                  key="N"
                  :label="$l('table_label_isCustomer_N') || '否'"
                  value="N"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('table_label_brand') || '品牌'"
              prop="brandCode"
            >
              <dict-select
                clearable
                v-model="form.brandCodeList"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                multiple
                url="/master/common/dict/brandSelect"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-form-item
            :label="$l('INDEX.table_label_modification_date') || '修改时间'"
            ><br />
            <el-col :span="11">
              <el-date-picker
                v-model="form.modifyBeginDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                :picker-options="modifyStartDatePicker"
                :placeholder="
                  $l('INDEX.Please select a start time') || '请选择开始时间'
                "
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="form.modifyEndDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                :picker-options="modifyEndDatePicker"
                :placeholder="
                  $l('INDEX.Please select an end time') || '请选择结束时间'
                "
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reload">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const initForm = { keyword: '', colorStatusList: ['A', 'S', 'Y', 'R'] }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
      modifyStartDatePicker: this.modifyDatetimeEnd(),
      modifyEndDatePicker: this.modifyDatetimeStart(),
    }
  },
  created() {
    this.query()
  },
  methods: {
    //初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reload')
      }
      this.$emit('query', this.form)
    },
    //高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    //重置条件查询
    reload() {
      this.form = { ...initForm }
    },
    //打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    //关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    //时间验证
    beginDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createEndDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.createEndDate).getTime() < time.getTime()
          }
        },
      }
    },
    processDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createBeginDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.createBeginDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    modifyDatetimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyEndDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.modifyEndDate).getTime() < time.getTime()
          }
        },
      }
    },
    modifyDatetimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyBeginDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.modifyBeginDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
